import React from 'react'
import HeaderOne from '../Components/Header/HeaderOne'
import Breadcrumb from '../Components/BreadCrumb/Breadcrumb'
import FaqInner from '../Components/Faq/FaqInner'
import ElementSection from '../Components/Elements/ElementSection'
import FaqContact from '../Components/Faq/FaqContact'
import FooterFour from '../Components/Footer/FooterFour'
import ScrollToTop from '../Components/ScrollToTop'
import SEO from '../Components/SEO/SEO'

function Faq() {
    return (
        <>
            <SEO 
                title="Frequently Asked Questions - Tourm Travel Agency"
                description="Find answers to frequently asked questions about our travel services, bookings, and policies. Get all the information you need."
                url="/faq"
            />
            <HeaderOne />
            <Breadcrumb
                title="FAQs"
            />
            <FaqInner />
            <ElementSection />
            <FaqContact />
            <FooterFour />
            <ScrollToTop />
        </>
    )
}

export default Faq
